import React from "react";
import PropTypes from "prop-types";
import ReUse from "../../../../services/helpers/reUse";
import LoaderForButton from "../../LoaderForButton";
import LoaderForContent from "../../LoaderForContent";

const CustomImage = ({ thumbnail, customClassName, altName, loadingState }) => {
	if (loadingState) return <LoaderForContent />;
	return (
		<img
			className={customClassName}
			alt={altName}
			src={
				thumbnail !== null
					? thumbnail && thumbnail
					: ReUse.defaultThumbnailImage({
							content: "No+Image+Available",
					  })
			}
			onError={ReUse.onImageError}
		/>
	);
};

CustomImage.propTypes = {
	thumbnail: PropTypes.string,
	customClassName: PropTypes.string,
};

CustomImage.defaultProps = {
	customClassName: "img-fluid",
	thumbnail: null,
	altName: "Sahara Image",
	loadingState: false,
};

export default CustomImage;
